import { create, StateCreator } from 'zustand';
import { persist, PersistOptions } from 'zustand/middleware';
import { IPermissionModel } from '../authGuard';

interface IRolesPermissionState {
	permissions: IPermissionModel[];
	role: string | null;
	setPermissions: (permissions: IPermissionModel[]) => void;
	setRole: (role: string | null) => void;
	reset: () => void;
}

const initialState: Omit<IRolesPermissionState, 'setPermissions' | 'setRole' | 'reset'> = {
	permissions: [],
	role: null,
};

type RolesPermissionPersist = (
	config: StateCreator<IRolesPermissionState>,
	options: PersistOptions<IRolesPermissionState>
) => StateCreator<IRolesPermissionState>;

export const useRolesPermission = create<IRolesPermissionState>(
	(persist as RolesPermissionPersist)(
		(set) => ({
			...initialState,
			setPermissions: (permissions: IPermissionModel[]): void => set((state) => ({ ...state, permissions })),
			setRole: (role: string | null): void => set((state) => ({ ...state, role })),
			reset: (): void => set(initialState),
		}),
		{
			name: 'permissions',
		}
	)
);
